import {
  GET_RAFFLE_CONCLUDED_TICKETS_SUCCESS,
  GET_RAFFLE_PLAYED_TICKETS_SUCCESS,
  GET_RAFFLE_TICKETS_FAILURE,
  GET_RAFFLE_TICKETS_REQUEST,
  RESET_RAFFLE_TICKETS_PAGINATION,
  GET_RAFFLE_TICKET_DETAIL_REQUEST,
  GET_RAFFLE_TICKET_DETAIL_SUCCESS,
  GET_RAFFLE_TICKET_DETAIL_FAILURE
} from 'Store/constants';
  
    
const initialState = {
  playedCoupons: {
    coupons: [],
    totalElements: 0,
    totalPages: 0
  },
  concludedCoupons: {
    coupons: [],
    totalElements: 0,
    totalPages: 0
  },
  pagination: {
    pageIndex: 0,
    pageSize: 10
  },
  ticketDetail: {},
  isLoading: true,
  error: null
};
    
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_RAFFLE_TICKETS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_RAFFLE_PLAYED_TICKETS_SUCCESS:
      return {
        ...state,
        playedCoupons: {
          coupons: [...state.playedCoupons.coupons, ...action.payload.userPlayedCoupons],
          totalElements: action.payload.totalElements,
          totalPages: action.payload.totalPages
        },
        pagination: { ...action.pagination },
        isLoading: false, error: null
      };
    case GET_RAFFLE_CONCLUDED_TICKETS_SUCCESS:
      return {
        ...state,
        concludedCoupons: {
          coupons: [...state.concludedCoupons.coupons, ...action.payload.userPlayedCoupons],
          totalElements: action.payload.totalElements,
          totalPages: action.payload.totalPages
        },
        pagination: { ...action.pagination },
        isLoading: false, error: null
      };
    case GET_RAFFLE_TICKETS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case RESET_RAFFLE_TICKETS_PAGINATION:
      return initialState;
    case GET_RAFFLE_TICKET_DETAIL_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_RAFFLE_TICKET_DETAIL_SUCCESS:
      return { ...state, ticketDetail: action.payload, isLoading: false, error: null };
    case GET_RAFFLE_TICKET_DETAIL_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};